import React from 'react';
import { CtaButton } from './CtaButton';
interface PricingCardsProps {
  compact?: boolean;
}
export function PricingCards({
  compact = false
}: PricingCardsProps) {
  return <div className="grid gap-6 md:grid-cols-2" data-id="element-177" data-mp="21f4ft53f8abg">
      {/* Pilates Clinic */}
      <div className="flex flex-col rounded-2xl border border-[var(--line)] bg-[var(--surface)] p-6 sm:p-8" data-id="element-178" data-mp="21h7h4la0xpvh">
        <div className="mb-4 flex items-center gap-2" data-id="element-179" data-mp="26buw9tj517xe">
          <span aria-hidden="true" data-id="element-180" data-mp="2bciuaz5sap14">📘</span>
          <h3 className="font-serif-display text-2xl font-bold text-[var(--text)]" data-id="element-181" data-mp="2bbhgimxdvofp">
            Pilates Clinic
          </h3>
        </div>
        <p className="mb-6 text-sm text-[var(--text-soft)]" data-id="element-182" data-mp="2k5cglgjneooh">
          6 Tomos + 6 Bonos · Adaptaciones profesionales completas
        </p>
        <div className="mb-6 mt-auto" data-id="element-183" data-mp="2p3xidkejtgf1">
          <p className="text-lg text-[var(--text-soft)] line-through" data-id="element-184" data-mp="2u4bouy0i4iay">$51.000</p>
          <p className="font-serif-display text-4xl font-bold text-[var(--text)] sm:text-5xl" data-id="element-185" data-mp="2z2wek3i4njl5">
            $19.990 <span className="text-xl text-[var(--slate)]" data-id="element-186" data-mp="3tgwht9r5v87o">ARS</span>
          </p>
        </div>
        <CtaButton href="https://www.tuplataformadigital.store/cart/47602579931220:1" variant="outline" size={compact ? 'md' : 'lg'} data-id="element-187" data-mp="3ohta1hjsqnw0">
          Quiero Pilates Clinic
        </CtaButton>
      </div>

      {/* Pilates Clinic PREMIUM */}
      <div className="relative flex flex-col rounded-2xl border-2 border-[var(--rose)] bg-[var(--surface-2)] p-6 shadow-[0_24px_50px_-30px_rgba(205,146,149,0.7)] sm:p-8" data-id="element-188" data-mp="3fiy3g4cubbs6">
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[var(--rose)] px-4 py-1 text-xs font-extrabold uppercase tracking-wide text-[var(--bg-deep)]" data-id="element-189" data-mp="b4836d4gxycv">
          ⭐ Más elegido
        </span>
        <div className="mb-4 flex items-center gap-2" data-id="element-190" data-mp="28im2ga1zq5a">
          <span aria-hidden="true" data-id="element-191" data-mp="ytj723h488v8">🏆</span>
          <h3 className="font-serif-display text-2xl font-bold text-[var(--text)]" data-id="element-192" data-mp="yuluu2j55v6x">
            Pilates Clinic Premium
          </h3>
        </div>
        <p className="mb-6 text-sm text-[var(--text-soft)]" data-id="element-193" data-mp="2o9d4gvzb6bov">
          6 Tomos + 6 Bonos + Pilates Business &amp; Protocols · Adaptaciones,
          cómo cobrar, red médica y escalamiento
        </p>
        <div className="mb-6 mt-auto" data-id="element-194" data-mp="2ekldor5zhxfj">
          <p className="text-lg text-[var(--text-soft)] line-through" data-id="element-195" data-mp="2ejjv81mn28ns">$69.000</p>
          <p className="font-serif-display text-4xl font-bold text-[var(--rose)] sm:text-5xl" data-id="element-196" data-mp="2jhbvbixft132">
            $27.990 <span className="text-xl text-[var(--rose)]" data-id="element-197" data-mp="25hkcn4vz6wiq">ARS</span>
          </p>
        </div>
        <CtaButton href="https://www.tuplataformadigital.store/cart/47602580324436:1" variant="rose" size={compact ? 'md' : 'lg'} data-id="element-198" data-mp="2ajt6s4kl44mf">
          Quiero Pilates Clinic Premium
        </CtaButton>
      </div>
    </div>;
}